<template>
  <div class="student_details_wrap"   v-loading="loading">
    <div class="student_details_title">
      <h2>我的分数明细</h2>
      <p>计分规则：总成绩（100分） = 课件学习（{{scoreData.coursewareRate}}）+单元测验（{{scoreData.unitExamRate}}）+课程考试（{{scoreData.courseExamRate}}）+考勤出勤率（{{scoreData.attendanceExamRate}}）</p>
    </div>
    <div class="student_details_scoring">
      <div>
        <b>{{scoreData.sumScore}}</b>
        <strong>分</strong>
        <span>当前课程总得分</span>
      </div>
      <span>=</span>
      <div>
        <b>{{scoreData.coursewareScore}}</b>
        <strong>分</strong>
        <span>课件学习</span>
      </div>
      <span>+</span>
      <div>
        <b>{{scoreData.unitExamScore}}</b>
        <strong>分</strong>
        <span>单元测验</span>
      </div>
      <span>+</span>
      <div>
        <b>{{scoreData.courseExamScore}}</b>
        <strong>分</strong>
        <span>课程考试</span>
      </div>
      <span>+</span>
      <div>
        <b>{{scoreData.attendanceExamScore}}</b>
        <strong>分</strong>
        <span>考勤</span>
      </div>
      <el-button class="relearning" @click="relearningFn" v-if="scoreData.showFlag==1">重新学习</el-button>
    </div>
    <div class="student_details_tab">
      <el-tabs v-model="activeName">
        <el-tab-pane label="课件学习" name="first">
          <CoursewareLearning :courseId="courseId" :classId="classId" :userId="userId"  v-if="activeName=='first'"></CoursewareLearning>
        </el-tab-pane>
        <el-tab-pane label="单元测验" name="second">
          <UnitTest :courseId="courseId" :classId="classId" :userId="userId" v-if="activeName=='second'"></UnitTest>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  
</template>
<script>
import * as api from "../../../../../../api/achievementApi";
import CoursewareLearning from './coursewareLearning'
import UnitTest from './unitTest'
export default {
  components: { CoursewareLearning, UnitTest },
  data() {
    return {
      loading: true,
      courseId: this.$route.query.id,
      classId:this.$route.query.classId,
      userId: sessionStorage.getItem('userId'),
      //   courseId:989,
      //  userId:59500,
      //  classId:1482,
      activeName: 'first',
      scoreData: {
        studentName: '',
        courseName: '',
        sumScore: '',
        coursewareScore: '',
        coursewareRate: '',
        unitExamScore: '',
        unitExamRate: '',
        courseExamScore: '',
        courseExamRate: '',
        attendanceExamRate: '',
        attendanceExamScore: '',
        showFlag: 0
      },
    
    }
  },
  mounted() {
    this.getData()
    // this.getIsJurisdiction()
    
  },
  methods: {
    getData(){
       let obj = {
        courseId: this.courseId,
        userId: this.userId,
        classId: this.classId,
      }
      api.getAchievementCourseHead(obj).then(rs=>{
       
        if(rs.code==0){
          this.loading = false
          this.scoreData = {
            studentName: rs.data.name,
            courseName: rs.data.courseName,
            sumScore: Number(rs.data.sumScore)?Number(rs.data.sumScore):rs.data.sumScore,
            coursewareScore: Number(rs.data.coursewareScore),
            coursewareRate: rs.data.coursewareRate||rs.data.coursewareRate==0 ? rs.data.coursewareRate+'%':'无',
            unitExamScore: Number(rs.data.unitExamScore),
            unitExamRate: rs.data.unitExamRate||rs.data.unitExamRate==0 ? rs.data.unitExamRate+'%':'无',
            courseExamScore: Number(rs.data.courseExamScore),
            courseExamRate: rs.data.courseExamRate||rs.data.courseExamRate==0 ? rs.data.courseExamRate+'%':'无',
            attendanceExamScore: Number(rs.data.attendanceExamScore),
            attendanceExamRate: rs.data.attendanceExamRate||rs.data.attendanceExamRate==0 ? rs.data.attendanceExamRate+'%':'无',
            showFlag: rs.data.showFlag
          }
        }else{
          // this.$messageError(rs.msg)
          this.loading = false
        }
      })
      let data = {
        courseId: this.courseId,
        classId: this.classId,
        queryParam: ''
      };
        api.getAchievementList(data).then(rs => {
        if (rs.code == 0) {
          
          this.headData=rs.data;
          console.log(rs);
        } else {
          this.$messageError(rs.msg);
        }
      });
    },
    // getIsJurisdiction(){
    //   this.$ajax.get('/api-user/sys/user/exist/userDetail').then(rs=>{
    //     if(rs.data.code==0){
    //       if(rs.data.data){
    //         this.isJurisdiction = true
    //       }else{
    //         this.isJurisdiction = false
    //       }
    //       this.loading = false
    //     }else{
    //       this.$messageError(rs.data.msg)
    //     }
    //   })
    // },
    relearningFn(){
      this.$tipsDialog(
        "提示",
        "重新学习后，当前课程学习记录将会清空，<br/>成绩归零，确定重新学习吗？",
        "",
        "el-icon-warning",
        "rgb(255, 178, 60)"
      ).then(() => {
        console.log('confirm')
      }).catch(() => {
        console.log('cancel')
      });
    },
    jump(){
      this.$router.push('/settings/studentStatus')
    }
  },
}
</script>
<style lang="scss">
  .student_details_wrap{
    background: #fff;
    margin:0 10px;
    padding: 0 24px;
    box-sizing: border-box;
    .student_details_title{
      display: flex;
      height: 50px;
      align-items: center;
      position: relative;
      h2{
        font-size:16px;
        font-weight:600;
        color:rgba(51,51,51,1);
      }
      p{
        font-size:12px;
        font-weight:400;
        color:rgba(51,51,51,1);
        margin-left: 24px;
      }
    }
    .student_details_scoring{
      width:100%;
      height:88px;
      background:rgba(233,241,253,1);
      border-radius:4px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 50px;
      box-sizing: border-box;
      div{
        width:160px;
        height:48px;
        background:rgba(255,255,255,1);
        box-shadow:0px 4px 8px rgba(0,0,0,0.14);
        border-radius:4px;
        color: #333;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        &:first-child{
          width:200px;
          height:48px;
          background:rgba(52,211,176,1);
          box-shadow:0px 4px 8px rgba(0,0,0,0.14);
          border-radius:4px;
          color: #fff;
          b{
            color: #fff;
          }
          strong{
            color: #fff;
          }
          span{
            color: #fff;
            &::after{
              background: #fff;
            }
          }
        }
        b{
          font-size:28px;
          font-weight:400;
        }
        strong{
          font-size:12px;
          margin: 0 5px;
        }
        span{
          font-size:12px;
          font-weight:400;
          color:#333;
          position: relative;
          margin-left: 20px;
          &::after{
            content: '';
            width:1px;
            height:10px;
            background: #333;
            position: absolute;
            left: -10px;
            top: 2px;
          }
        }
      }
      .relearning{
        width:124px;
        height:40px;
        background:rgba(83,151,247,1);
        border-radius:4px;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
      }
    }
    .student_details_tab{
      /deep/ .el-tabs{
        .el-tabs__item{
          color: #999999;
          font-weight: 600;
        }
        .el-tabs__item.is-active{
          color: #333333;
        }
        .el-tabs__active-bar{
          background: #333333;
        }
      }
    }
  }
  .no_details_wrap{
    height: 100%;
    background: #fff;
    margin:0 10px;
    padding: 0 24px;
    box-sizing: border-box;
    text-align: center;
    img{
      height: 240px;
      margin: 100px 0 24px 0;
    }
    p{
      font-size:14px;
      font-weight:400;
      color:rgba(51,51,51,1);
      span{
        color: #5397F7;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/achievement/student/index.vue